var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoPage",class:{'fullImg': _vm.fullImg, min: _vm.minHeader },style:({ backgroundImage: _vm.bgUrl })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/logo.svg"),"alt":"Нова Пошта"}})])
}]

export { render, staticRenderFns }